import { render } from "./ComparisonCardGroup.vue?vue&type=template&id=1151aedb"
import script from "./ComparisonCardGroup.vue?vue&type=script&lang=js"
export * from "./ComparisonCardGroup.vue?vue&type=script&lang=js"

import "./ComparisonCardGroup.vue?vue&type=style&index=0&id=1151aedb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__